import { _ACTIVITIES } from "./constants";

export const _SAVE_DATA_FLEET_OPTIMISATION = [
  {
    activity: _ACTIVITIES.AGG,
    theme: [{ name: "Loaders", quantity: 1 }],
  },
  {
    activity: _ACTIVITIES.BLOCK,
    theme: [
      { name: "Forklift", quantity: 1 },
      { name: "Skid steer Loaders", quantity: 1 },
    ],
  },
  {
    activity: "OVH",
    theme: [{ name: "Lorries block", quantity: 2 }],
  },
];

export const _SAVE_CATEGORY_FLEET_OPTIMISATION = "fleet_optimisation";

const payrollThemes = [
  { name: "basic", quantity: 1 },
  { name: "overtime", quantity: 1 },
  { name: "eoy_bonus", quantity: 1 },
  { name: "merit_bonus", quantity: 1 },
  { name: "production_bonus", quantity: 1 },
  { name: "other_allow", quantity: 1 },
  { name: "meal_allowance", quantity: 1 },
  { name: "medical_expenses", quantity: 1 },
  { name: "nps_ewf_ivtb", quantity: 1 },
  { name: "travelling", quantity: 1 },
];

export const _SAVE_DATA_PAYROLL = [
  {
    activity: _ACTIVITIES.AGG,
    theme: payrollThemes,
  },
  {
    activity: _ACTIVITIES.BLOCK,
    theme: payrollThemes,
  },
  {
    activity: "OVH",
    theme: payrollThemes,
  },
  {
    activity: "PRECAST",
    theme: payrollThemes,
  },
  {
    activity: _ACTIVITIES.LRU,
    theme: payrollThemes,
  },
  {
    activity: "CCP",
    theme: payrollThemes,
  },
  {
    activity: "MARBLE",
    theme: payrollThemes,
  },
  {
    activity: "RUSTIC",
    theme: payrollThemes,
  },
  {
    activity: "VORTEX",
    theme: payrollThemes,
  },
  {
    activity: "PREDALLES",
    theme: payrollThemes,
  },
  {
    activity: "POUTRELLES",
    theme: payrollThemes,
  },
  {
    activity: "WS",
    theme: payrollThemes,
  },
  {
    activity: "FLEET OP",
    theme: payrollThemes,
  },
  {
    activity: "ADMIN",
    theme: payrollThemes,
  },
  {
    activity: "FINANCE",
    theme: payrollThemes,
  },
  {
    activity: "OTHER",
    theme: payrollThemes,
  },
];

export const _SAVE_CATEGORY_PAYROLL = "payroll";

export const _SAVE_CATEGORY_HUMAN_RESSOURCES = "human_ressources";

export const _SAVE_DATA_HUMAN_RESSOURCES = [
  {
    activity: "OVH",
    theme: [
      { name: "Staff Welfare", quantity: 1 },
      { name: "Staff EOY Gift", quantity: 1 },
      { name: "Uniform", quantity: 1 },
      { name: "Donation", quantity: 1 },
      { name: "Canteen", quantity: 1 },
      { name: "Staff training", quantity: 1 },
      { name: "Entertainment", quantity: 1 },
      { name: "Selling & Marketing", quantity: 1 },
    ],
  },
];

export const _SAVE_DATA_SALES_BLOCK = [
  {
    activity: _ACTIVITIES.BLOCK,
    theme: [
      { name: "external_volume", quantity: 1 },
      { name: "internal_volume", quantity: 1 },
      { name: "external_value", quantity: 1 },
      { name: "internal_value", quantity: 1 },
    ],
  },
];

export const _SAVE_HANDLE_SALES_BLOCK_THEME = {
  "Internal Values": "internal_value",
  "External Volumes": "external_volume",
  "Internal Volumes": "internal_volume",
  "External Values": "external_value",
};
export const _SAVE_CATEGORY_SALES_BLOCK = "sales_block";

export const LINKED_DEPOT_DATA = [
  {
    activity: _ACTIVITIES.AGG,
    theme: [
      { name: "External Volumes", quantity: 1 },
      { name: "Internal Volumes", quantity: 1 },
    ],
  },
];

export const SAVE_CATEGORY_SALES_DEPOT = "sales_depot";

export const LINKED_AGGREGATE_DATA = [
  {
    activity: _ACTIVITIES.AGG,
    theme: [
      { name: "INTERNAL TURN OVER", quantity: 1 },
      { name: "EXTERNAL TURN OVER", quantity: 1 },
      { name: "INTERNAL VOLUMES", quantity: 1 },
      { name: "EXTERNAL VOLUMES", quantity: 1 },
    ],
  },
];

export const SAVE_CATEGORY_AGGREGATE = "sales_aggregate";
